export const SOCIAL_MEDIA_HANDLES = {
  GITHUB: "github",
  LINKEDIN: "linkedin",
  TWITTER: "twitter",
};

export const SOCIAL_MEDIA_LINKS = {
  GITHUB: "https://github.com/calcont/whiteboard",
  TWITTER: "https://twitter.com/amarkhamkar6",
};

export const HELP_LINKS = {
  GITHUB_CONTRIBUTING:
    "https://github.com/calcont/whiteboard/blob/master/CONTRIBUTION.md",
  GITHUB_ISSUES: "https://github.com/calcont/whiteboard/issues",
};
